import { apiClient } from '../../../core/api/client';
import { RiderMissionListResponse } from '../types/mission.types';

const BASE_PATH = '/api/v1/mob/mission';

export const getRiderMissionList = async (): Promise<RiderMissionListResponse> => {
    const response = await apiClient.get<RiderMissionListResponse>(`${BASE_PATH}/list`);
    return response.data;
};
